module.exports = __webpack_public_path__ + "img/songlv.73a2743a.png";